import { render } from "./DailyBookingPage.vue?vue&type=template&id=56ec6d39&scoped=true"
import script from "./DailyBookingPage.vue?vue&type=script&lang=js"
export * from "./DailyBookingPage.vue?vue&type=script&lang=js"

import "./DailyBookingPage.vue?vue&type=style&index=0&id=56ec6d39&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ec6d39"]])

export default __exports__